<template>
  <div class="mt-6">
    <div v-if="label" class="mb-2">
      <label for="cover_photo" class="block text-sm leading-5 font-medium text-gray-700 sm:mt-px sm:pt-2">
        {{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span>
      </label>
    </div>
    <div class="cursor-pointer mt-2 sm:mt-0 sm:col-span-3">
      <div
        @click="$refs.file.click()"
        class="flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
      >
        <div v-if="!file && !files" class="text-center">
          <svg
            v-if="!imageholder"
            class="mx-auto h-12 w-12 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="mt-1 text-sm text-gray-600">
            <input
              ref="file"
              type="file"
              style="display: none"
              @change="onFileChange($event)"
              :multiple="multiple"
              :accept="accept"
            />
          </p>
          <p v-if="!imageholder" class="mt-1 text-xs text-gray-500">Click to upload {{ limits }}</p>
          <img v-if="imageholder" class="h-20 w-auto" :src="imageholder" />
        </div>
        <div v-else>
          <div v-if="multiple">
            <p v-for="f of files" :key="f.name" class="mt-1 text-xs text-gray-500">
              {{ f.name }}
            </p>
          </div>
          <div v-else class="mt-1 text-xs text-gray-500">
            <p class="mt-1 text-xs text-gray-500">
              {{ file.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'limits', 'placeholder', 'optional', 'disabled', 'imageholder', 'multiple', 'accept'],
  data() {
    return {
      textValue: this.modelValue,
      hasFiles: false,
      file: null,
      files: null,
    };
  },
  methods: {
    onFileChange(event) {
      if (this.multiple) {
        this.$emit('update:modelValue', event.target.files);
        this.files = event.target.files;
      } else {
        this.$emit('update:modelValue', event.target.files[0]);
        this.file = event.target.files[0];
      }
    },
  },
};
</script>
